import * as React from 'react';
import { observer } from 'mobx-react';
import { IPlayerInfoParams } from './IPlayerInfoParams';
import { ImageHandler } from 'Components/ImageHandler';

@observer
export class PlayerInfo extends React.Component<IPlayerInfoParams> {
  constructor(props: IPlayerInfoParams) {
    super(props, undefined);
  }
  render() {
    return (
      <div className="PlayerInfo">
        <div>
          {this.props.isWeb && this.props.currentPlayer && (
            <span className="player-img">
              <img
                src={ImageHandler.getImageUrl('15097e3d-401f-e111-a3d4-e0f8471af54b')}
                alt="player"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = 'Images/no-avatar.png';
                }}
              />
            </span>
          )}
          {this.props.currentPlayer.image && !this.props.isWeb && (
            <span className="player-img">
              <img src={this.props.currentPlayer.image} alt="player" />
            </span>
          )}
          {!this.props.currentPlayer.image && !this.props.isWeb && (
            <span className="player-img">
              <img src="Images/no-avatar.png" alt="player" />
            </span>
          )}
          <span className="player-name">{this.props.currentPlayer.name}</span>
        </div>
      </div>
    );
  }
}
